import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const httpGenerator: LanguageGenerator = {
  id: 'http',
  name: 'HTTP',
  category: 'request-examples',
  color: '#009688',
  generate(config: ExportConfig): GeneratedFile[] {
    const serviceUrl = config.serviceUrl || 'https://mail.yourdomain.com';
    const lines: string[] = [
      '# mail_requests.http — generated by Mail Service SDK Export',
      '# Compatible with VS Code REST Client, JetBrains HTTP Client, etc.',
      '',
    ];

    for (const app of config.apps) {
      lines.push(`### ── ${app.name} ────────────────────────────────────`);
      lines.push('');
      for (const t of app.templates) {
        const exampleData = t.schema
          ? t.schema.reduce<Record<string, unknown>>((acc, f) => {
              acc[f.key] = f.type === 'number' ? Number(f.example || 0) : f.type === 'boolean' ? true : (f.example || f.key);
              return acc;
            }, {})
          : {};
        lines.push(`### Send: ${t.name}`);
        lines.push(`POST ${serviceUrl}/v1/send`);
        lines.push('Content-Type: application/json');
        lines.push(`X-API-KEY: {{${app.envVarName}}}`);
        lines.push('');
        lines.push(JSON.stringify({ template_slug: t.slug, recipient: 'user@example.com', data: exampleData }, null, 2));
        lines.push('');
      }
    }

    return [
      { filename: 'mail_requests.http', content: lines.join('\n'), syntax: 'http' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
